"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SearchBarInput_1 = __importDefault(require("@/components/input/SearchBarInput"));
const principalToAccountId_1 = require("@/utils/principalToAccountId");
const principal_1 = require("@dfinity/principal");
const Section_1 = __importDefault(require("@/components/layout/Section"));
const PageTitle_1 = __importDefault(require("@/components/layout/PageTitle"));
const SearchResultList_1 = __importDefault(require("@/components/list/SearchResultList"));
const SimpleTable_1 = __importDefault(require("@/components/list/SimpleTable"));
const fetchData_1 = require("@/utils/fetchData");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const themes_1 = require("@/theme/themes");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const react_router_dom_1 = require("react-router-dom");
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
const Explorer = () => {
    const [search, setSearch] = (0, react_1.useState)();
    const [principal, setPrincipal] = (0, react_1.useState)("");
    const [accId, setAccId] = (0, react_1.useState)("");
    const [searchResult, setSearchResult] = (0, react_1.useState)();
    const [history, setHistory] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [isPageloading, setPageLoading] = (0, react_1.useState)(true);
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const onChange = (e) => {
        setSearch(e.target.value);
    };
    const searchData = async (search) => {
        let tmpAccId = "";
        try {
            const p = principal_1.Principal.fromText(search || "");
            tmpAccId = (0, principalToAccountId_1.getAccountId)(p);
            setAccId(tmpAccId);
            setPrincipal(search);
        }
        catch {
            setPrincipal('');
        }
        const result = tmpAccId ? await Promise.all([(0, fetchData_1.getSearchQuery)(search), (0, fetchData_1.getSearchQuery)(tmpAccId)]) : await Promise.all([(0, fetchData_1.getSearchQuery)(search)]);
        const [searchPromiseResult, accIdResult] = await Promise.all(result);
        if (accIdResult) {
            searchPromiseResult.data = [...searchPromiseResult.data, ...accIdResult.data];
            searchPromiseResult.totalResults = searchPromiseResult.totalResults + accIdResult.totalResults;
        }
        setSearchResult(searchPromiseResult || accIdResult);
        setLoading(false);
    };
    const initFetchData = async () => {
        try {
            const searchParams = new URLSearchParams(window.location.search);
            const result = await Promise.all([(0, fetchData_1.getTransactionHistory)(parseInt(searchParams.get("page")) || 1, 10)]);
            const [historyResult] = await Promise.all(result);
            setHistory(historyResult);
            setPageLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    (0, react_1.useEffect)(() => {
        initFetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        if (search && search.length > 3) {
            setLoading(true);
        }
        const delay = setTimeout(() => {
            if (search && search.length > 3) {
                searchData(search);
            }
        }, 1000);
        return () => clearTimeout(delay);
    }, [search]);
    return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: "24px" },
        react_1.default.createElement(HelmetTitle_1.default, { title: 'OGY Explorer', description: 'Here you can search for all OGY transactions' }),
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
            react_1.default.createElement(PageTitle_1.default, { title: "Explorer" }),
            react_1.default.createElement(Section_1.default, null,
                react_1.default.createElement(SearchBarInput_1.default, { onChange: onChange })),
            searchResult && (react_1.default.createElement(Section_1.default, null,
                react_1.default.createElement(SearchResultList_1.default, { searchResult: searchResult, loading: loading }))),
            react_1.default.createElement(Section_1.default, { isLoading: isPageloading },
                react_1.default.createElement(SimpleTable_1.default, { dataFetching: fetchData_1.getTransactionHistory, initData: history, isPageLoading: isPageloading, colWidth: {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    } })))));
};
exports.default = Explorer;
